/** Gerado por apps/web/scripts/write-build-info.mjs — não editar. */
export const APP_VERSION = "1.1.0";
export const APP_BUILT_AT = "2026-10-06";
